import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import globalContext from '../../../config/context';
import useHook from '../Pendataan/pendataan.hooks';
import './style.css';

//material core
import Button from '@material-ui/core/Button';
import {grey} from '@material-ui/core/colors';

import Dialog from '@material-ui/core/Dialog/Dialog';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import {Card, CardContent, Grid, Typography} from '@material-ui/core';
import {Doughnut, Line} from 'react-chartjs-2';
import numeral from 'numeral';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  //button
  button: {
    // position: 'absolute',
    bottom: 30,
    left: 105,
    borderRadius: 7,
  },

  //legend content
  box: {
    width: '100vw',
    // padding: '2vh',
    // height: 290,
    // display:'block',
    position: 'absolute',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //options
  options: {
    position: 'relative',
    padding: 20,
    backgroundColor: '#fafafa',
    textAlign: 'left',
  },
  gridCaption: {
    position: 'absolute',
    bottom: 20,
  },
  caption: {
    fontSize: 18,
    fontWeight: 500,
  },
  gridComboBox: {
    marginLeft: 90,
  },
  comboBox: {
    width: '100%',
    disabled: 'true',
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  label: {
    // fontSize: 13,
    textTransform: 'capitalize',
  },
}))(Button);

const PendataanTarget = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{checkedPendataan}] = useAppContext();
  const [{kinerjaTarget, kinerjaTargetTotal}] = useHook(props);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const data = {
    labels: kinerjaTarget.map((o) => o.text),
    datasets: [
      {
        backgroundColor: ['#179d00', '#ecfc00', '#CA0617', '#20B2AA', '#9932CC', '#4169E1', '#9c4f1f'],
        borderColor: ['#179d00', '#ecfc00', '#CA0617', '#20B2AA', '#9932CC', '#4169E1', '#9c4f1f'],

        borderWidth: 1,
        data: kinerjaTarget.map((o) => o.jumlah),
      },
    ],
  };

  let options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
    },
  };

  return (
    <div>
      <ColorButton
        variant="contained"
        color="default"
        size="small"
        className={classes.button}
        startIcon={<TrackChangesIcon />}
        onClick={handleClickOpen}>
        Target
      </ColorButton>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <PerfectScrollbar>
          <DialogContent style={{backgroundColor: '#efeff1'}}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Card style={{backgroundColor: '#4759a1', height: 240, marginBottom: 20}}>
                  <CardContent>
                    <Typography align={'left'} variant={'h6'} style={{color: 'white'}}>
                      POTENSI PENDATAAN
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354', marginTop: 10}}>
                      Jumlah Pendataan :
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354'}}>
                      {numeral(kinerjaTargetTotal.jumlah).format('0,0')}
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354', marginTop: 10}}>
                      Target Pendataan :
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354'}}>
                      {numeral(kinerjaTargetTotal.target).format('0,0')}
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354', marginTop: 10}}>
                      Persentase :
                    </Typography>
                    <Typography align={'left'} style={{color: '#f8e354'}}>
                      {kinerjaTargetTotal.persen}
                    </Typography>
                  </CardContent>
                </Card>
                <div>
                  <Typography align={'left'} variant={'subtitle1'} style={{marginBottom: 15}}>
                    AKUMULASI DATA PENDATAAN
                  </Typography>
                  {kinerjaTarget.map((value, key) => {
                    return (
                      <div key={key}>
                        <div>{value.text + ' : '}</div>
                        <div style={{marginBottom: 15, marginTop: 5}}>
                          {numeral(value.jumlah).format('0,0') + ' (' + value.persen + ')'}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Grid>

              <Grid item xs={12} md={8}>
                <Card>
                  <CardContent>
                    <Doughnut data={data} options={options} />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DialogContent>
        </PerfectScrollbar>
      </Dialog>
    </div>
  );
};
export default PendataanTarget;
